<template>
  <div class="BoxFront">
    <div class="contentFront">
      <div class="headerInventory">
        <span>Movimentações de agrotóxicos </span>
        <b-button
          v-if="dataInventory.idVenda"
          class="form-btn-inventory"
          @click="openPrescription"
        >
          Abrir Receita {{ this.receita ? `N° ${this.receita}` : "" }}</b-button
        >
      </div>

      <div class="formFront">
        <div class="rowContainer">
          <span>
            <b-icon-box-seam />
            Informações do agrotóxico
          </span>

          <div class="rowContent">
            <div style="flex: 1 1 30%; min-width: 265px">
              <InputProducts
                key="agro"
                label="Agrotóxicos"
                typeFilter="pesticides"
                :isEdit="dataInventory.id || dataInventory.idAgrotoxico"
                :dataInput.sync="dataInventory.idAgrotoxico"
                :onSearch="fillPesticidesComboBoxWithPaginate"
                :clearSelected="toggleClearSelect"
                :searchFields="['nomeComum']"
                :isInvalidInput="invalidFields?.idAgrotoxico || ''"
                @selectItem="getAllEmbalagensAgrotoxico"
                @clearInvalidInput="clearInvalidFields('idAgrotoxico')"
              />
            </div>

            <div style="flex: 1 1 25%; min-width: 200px">
              <InputSelect
                style="width: 100%"
                label="Fornecedor"
                valueField="id"
                textField="nomeFantasia"
                :items="allSupplier"
                :dataSelect.sync="dataInventory.idFornecedor"
                :isInvalidInput="invalidFields?.idFornecedor || ''"
                :openCreateModal="() => openModals('modalCreateSupplier')"
                @clearInvalidInput="clearInvalidFields('idFornecedor')"
                ref="idFornecedor"
              />
            </div>

            <div style="flex: 1 1 10%; min-width: 140px">
              <InputSelect
                style="width: 100%"
                label="Embalagens"
                valueField="descricao"
                textField="descricao"
                :items="listEmbalagens"
                :dataSelect.sync="dataInventory.embalagem"
                :dataInput="dataInventory.embalagem"
                :enableIconCreate="false"
                :isInvalidInput="invalidFields?.embalagem || ''"
                @clearInvalidInput="clearInvalidFields('embalagem')"
                @selectedIten="handleAssingEmb"
                ref="embalagem"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 150px; min-width: 120px">
              <!-- <Input
                style="width: 100%"
                label="Quantidade"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.quantidade"
                :isInvalidInput="invalidFields?.quantidade || ''"
                @clearInvalidInput="clearInvalidFields('quantidade')"
                ref="quantidade"
              /> -->

              <InputQuant
                style="width: 100%"
                label="Quantidade"
                type="text"
                labelFixed
                :dataInput.sync="dataInventory.quantidade"
                :isInvalidInput="invalidFields?.quantidade || ''"
                @clearInvalidInput="clearInvalidFields('quantidade')"
                ref="quantidade"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 200px; min-width: 200px">
              <Input
                style="width: 100%"
                label="Lote"
                labelFixed
                :dataInput.sync="dataInventory.lote"
                :isInvalidInput="invalidFields?.lote || ''"
                @clearInvalidInput="clearInvalidFields('lote')"
                ref="lote"
              />
            </div>
          </div>

          <div class="rowContent">
            <div class="input-group" style="width: 100%">
              <label class="user-label-obs"> Observações </label>

              <textarea
                rows="3"
                max-rows="6"
                class="input borderInput inputTextArea"
                type="number"
                v-model="dataInventory.observacao"
              />
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill>
            Informações Gerais</span
          >

          <div class="rowContent">
            <div style="flex: 1 1 auto; min-width: 300px">
              <InputSelect
                style="width: 100%"
                label="Responsável Técnico"
                valueField="id"
                textField="nome"
                :items="responsibles"
                :dataSelect.sync="dataInventory.idResponsavel"
                :dataInput="dataInventory.idResponsavel"
                :isInvalidInput="invalidFields?.idResponsavel || ''"
                :openCreateModal="() => openModals('modalResponsible')"
                @clearInvalidInput="clearInvalidFields('idResponsavel')"
                ref="idResponsavel"
              />
            </div>

            <div style="flex: 1 1 15%; min-width: 135px">
              <InputSelect
                style="width: 100%"
                label="Tipo de Movimentação"
                valueField="value"
                textField="text"
                :items="movimentTypes"
                :dataSelect.sync="dataInventory.tipo"
                :dataInput="dataInventory.tipo"
                :enableIconCreate="false"
                :isInvalidInput="invalidFields?.tipo || ''"
                @clearInvalidInput="clearInvalidFields('tipo')"
                @selectedIten="setInventoryDefaults($event, true)"
                ref="tipo"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 150px; min-width: 150px">
              <Input
                style="width: 100%"
                label="Data"
                type="date"
                labelFixed
                :dataInput.sync="dataInventory.data"
                :isInvalidInput="invalidFields?.data || ''"
                @clearInvalidInput="clearInvalidFields('data')"
                ref="data"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 150px; min-width: 150px">
              <Input
                style="width: 100%"
                label="Data Vencimento"
                type="date"
                labelFixed
                :dataInput.sync="dataInventory.dataVencimento"
                ref="dataVencimento"
              />
            </div>
          </div>
        </div>

        <div class="rowContainer">
          <span>
            <b-icon-receipt-cutoff />
            Informações fiscais
          </span>

          <div class="rowContent">
            <div style="flex: 1 1; max-width: 150px; min-width: 150px">
              <Input
                style="width: 100%"
                label="Data NF-e"
                type="date"
                labelFixed
                :dataInput.sync="dataInventory.dataNfe"
                :isInvalidInput="invalidFields?.dataNfe || ''"
                @clearInvalidInput="clearInvalidFields('dataNfe')"
                ref="dataNfe"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 150px; min-width: 145px">
              <Input
                style="width: 100%"
                label="Nº NF-e"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.numeroNfe"
                :isInvalidInput="invalidFields?.numeroNfe || ''"
                @clearInvalidInput="clearInvalidFields('numeroNfe')"
                ref="numeroNfe"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 150px; min-width: 145px">
              <Input
                style="width: 100%"
                label="Serie"
                type="number"
                labelFixed
                :dataInput.sync="dataInventory.serieNfe"
                :isInvalidInput="invalidFields?.serieNfe || ''"
                @clearInvalidInput="clearInvalidFields('serieNfe')"
                ref="serieNfe"
              />
            </div>

            <div style="flex: 1 1 15%; max-width: 200px; min-width: 150px">
              <InputSelect
                style="width: 100%"
                label="Destino"
                valueField="value"
                textField="text"
                :items="tipoOperacao"
                :dataSelect.sync="dataInventory.destinoProduto"
                :dataInput="dataInventory.destinoProduto"
                :isInvalidInput="invalidFields?.destinoProduto || ''"
                :enableIconCreate="false"
                @clearInvalidInput="clearInvalidFields('destinoProduto')"
                ref="destinoProduto"
              />
            </div>

            <div class="selectPlus" style="flex: 1 1 15%; min-width: 162px">
              <InputSelect
                style="width: 100%"
                label="Natureza de Operação"
                valueField="value"
                textField="text"
                :items="natureOps"
                :dataSelect.sync="dataInventory.naturezaOperacao"
                :dataInput="dataInventory.naturezaOperacao"
                :isInvalidInput="invalidFields?.naturezaOperacao || ''"
                :enableIconCreate="false"
                @clearInvalidInput="clearInvalidFields('naturezaOperacao')"
                ref="naturezaOperacao"
              />
            </div>
          </div>
        </div>

        <div class="content-form-btn">
          <b-button class="form-btn" @click="clearInputs">Novo</b-button>
          <b-button
            class="form-btn"
            :disabled="loading"
            @click="handleSaveOrUpdate"
          >
            Salvar</b-button
          >
        </div>
      </div>

      <b-modal id="modal-1" hide-footer hide-header size="lg">
        <button class="closeModal" @click="$bvModal.hide('modal-1')">
          <b-icon-x scale="1.3"></b-icon-x>
        </button>
      </b-modal>

      <ModalCreateSupplier
        @getAllNewSupplier="getAllSuppliers"
        :idSupplierFromSearch="dataInventory.idFornecedor"
      />
      <ModalResponsible @getAllResponsibles="getAllResponsibles" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { DateTime } from "luxon";

import ModalCreateSupplier from "../Modals/ModalCreateSupplier.vue";
import ModalResponsible from "../Modals/ModalResponsible.vue";
import InputProducts from "../../components/UI/CustomInputs/InputProducts.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import Input from "../../components/UI/CustomInputs/Input.vue";
import InputQuant from "../../components/UI/CustomInputs/InputQuant.vue";

import ServiceSupplier from "../../services/serviceSupplier";
import ServiceResponsible from "../../services/serviceResponsible";
import ServiceCompendio from "../../services/serviceCompendio";
import ServiceMovimentPesticides from "../../services/serviceMovimentPesticides";

import { removeReference } from "../../utils/removeReference";
import { HandleErrors } from "../../utils/handleErrors";
import { ValidateMovimentPerticides } from "../../validators/movimentPerticides";
import {
  INITIAL_STATE_MOVIMENT_PESTICIDES,
  INVALID_FIELDS_MOVIMENT_PESTICIDES,
} from "../../initialStates/movimentPesticides";

export default {
  components: {
    InputSelect,
    InputProducts,
    Input,
    InputQuant,
    ModalCreateSupplier,
    ModalResponsible,
  },
  props: {
    dataEditPurchase: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      getAllProducts: null,
      allSupplier: [],
      responsibles: [],
      dataInventory: removeReference(INITIAL_STATE_MOVIMENT_PESTICIDES),
      invalidFields: removeReference(INVALID_FIELDS_MOVIMENT_PESTICIDES),
      natureOps: [
        { value: "Entrada", text: "Entrada" },
        { value: "Saida", text: "Saída" },
        { value: "", text: "Selecione..." },
      ],
      movimentTypes: [
        { value: "", text: "Selecione..." },
        { text: "Compra", value: "Compra" },
        { text: "Entrada", value: "Entrada" },
        { text: "Inventario Entrada", value: "Inventario Entrada" },
        { text: "Transferência Entrada", value: "Transferência Entrada" },
        { text: "Devolução Entrada", value: "Devolução Entrada" },
        { text: "Devolução Saída", value: "Devolução" },
        { text: "Inventario Saida", value: "Inventario Saida" },
        { text: "Transferência Saida", value: "Transferência Saida" },
        { text: "Venda", value: "Venda" },
      ],
      tipoOperacao: [
        { text: "Dentro do estado", value: "Dentro Estado" },
        { text: "Fora do estado", value: "Fora Estado" },
      ],
      listEmbalagens: [],
      toggleClearSelect: false,
      receita: null,
    };
  },
  methods: {
    ...mapMutations(["SET_ID_TRANSFORM_COMPLETED_SALE"]),
    async handleSaveOrUpdate() {
      this.setInventoryDefaults();

      if (!this.validate()) {
        return;
      }

      this.dataInventory.id ? await this.update() : await this.save();
    },

    setInventoryDefaults(type = this.dataInventory.tipo, updateNature = false) {
      const natureByInventoryType = {
        "Inventario Entrada": "Entrada",
        "Inventario Saida": "Saida",
      };
      const natureOperation = natureByInventoryType[type];

      if (!natureOperation) return;

      if (!this.dataInventory.dataNfe) {
        this.dataInventory.dataNfe = DateTime.local().toFormat("yyyy-MM-dd");
      }

      if (!this.dataInventory.numeroNfe) this.dataInventory.numeroNfe = "1";
      if (!this.dataInventory.serieNfe) this.dataInventory.serieNfe = "1";

      if (updateNature || !this.dataInventory.naturezaOperacao) {
        this.dataInventory.naturezaOperacao = natureOperation;
      }

      this.$nextTick(this.syncInventoryDefaultRefs);
    },

    syncInventoryDefaultRefs() {
      ["dataNfe", "numeroNfe", "serieNfe"].forEach((key) => {
        if (this.$refs[key]) {
          this.$refs[key].valueInput = this.dataInventory[key];
        }
      });

      if (this.$refs.naturezaOperacao) {
        this.$refs.naturezaOperacao.valueItems =
          this.dataInventory.naturezaOperacao;
      }
    },

    async save() {
      try {
        this.loading = true;
        const result = await ServiceMovimentPesticides.save({
          ...this.dataInventory,
          criarNaEmpresaDeRefercia: [
            "Transferência Saida",
            "Transferência Entrada",
          ].includes(this.dataInventory.tipo)
            ? true
            : false,
        });

        this.dataInventory.id = result.id;

        this.$toast.open({
          message: "Nova movimentação registrada!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.loading = false;
      }
    },

    async update() {
      try {
        this.loading = true;

        await ServiceMovimentPesticides.update(
          this.dataInventory.id,
          this.dataInventory
        );

        this.$toast.open({
          message: "Movimentação Atualizada!",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });

        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return this.$toast.open({
            message: `${error.response.data.message}`,
            type: "error",
          });
      } finally {
        this.loading = false;
      }
    },

    async fillPesticidesComboBoxWithPaginate(
      id,
      q,
      filterType,
      page,
      typeProduct
    ) {
      try {
        const { data } = await ServiceCompendio.combobox(
          id,
          q,
          filterType,
          page,
          typeProduct
        );

        return data?.map((agro) => {
          return {
            id: +agro.id,
            nome: agro.nomeComum,
            registro: agro.registro,
          };
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });

        return;
      }
    },

    async getAllSuppliers() {
      const selectedId = this.dataSearchFromMovimentPesticides.id
        ? this.dataSearchFromMovimentPesticides.idFornecedor
        : undefined;
      this.allSupplier = await ServiceSupplier.fillComobobox(selectedId);
    },

    async getAllResponsibles() {
      this.responsibles = await ServiceResponsible.findAll();
    },

    async getAllEmbalagensAgrotoxico(agrotoxico) {
      this.listEmbalagens =
        await ServiceCompendio.findAllEmbalagensByIdAgrotoxico(agrotoxico.id);
    },

    async openPrescription() {
      this.SET_ID_TRANSFORM_COMPLETED_SALE(this.dataInventory.idVenda);
      const route =
        this.dataInventory.tipoVenda === "Receita" ? "/receita" : "vendas";
      this.$router.push(route);
    },

    validate() {
      const isNotValid = ValidateMovimentPerticides(this.dataInventory);
      return this.handleValidateErrors(isNotValid);
    },

    handleAssingEmb(emb) {
      this.dataInventory.embalagem =
        this.listEmbalagens.find((embItem) => embItem.descricao === emb)
          ?.descricao || null;
    },

    handleValidateErrors(errors) {
      if (errors && errors.length) {
        errors.forEach((erro) => {
          this.invalidFields[erro.keyError] = "isInvalidInput";
        });

        this.$toast.open({
          message: "Existem campos obrigatórios!",
          type: "info",
        });

        return false;
      }

      return true;
    },

    clearInvalidFields(key) {
      if (this.invalidFields[key]) this.invalidFields[key] = "";
    },

    clearInputs() {
      this.dataInventory = removeReference(INITIAL_STATE_MOVIMENT_PESTICIDES);
      this.invalidFields = removeReference(INVALID_FIELDS_MOVIMENT_PESTICIDES);

      this.toggleClearSelect = !this.toggleClearSelect;
      this.clearRefs();
    },

    clearRefs() {
      Object.keys(INITIAL_STATE_MOVIMENT_PESTICIDES).forEach((key) => {
        if (this.$refs[key] && this.$refs[key]?.valueInput)
          this.$refs[key].valueInput = "";
        else if (this.$refs[key] && this.$refs[key]?.valueItems)
          this.$refs[key].valueItems =
            key === "destinoProduto" ? "Dentro Estado" : "";
      });
    },

    handleAssingToEdit() {
      if (this.dataSearchFromMovimentPesticides.id) {
        Object.assign(
          this.dataInventory,
          this.dataSearchFromMovimentPesticides
        );

        Object.keys(INITIAL_STATE_MOVIMENT_PESTICIDES).forEach((key) => {
          const ref = this.$refs[key];

          if (ref && "valueInput" in ref)
            this.$refs[key].valueInput = this.dataInventory[key];
          else if (ref && "valueItems" in ref)
            this.$refs[key].valueItems = this.dataInventory[key];
        });
      }
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
  },
  computed: {
    ...mapState(["dataSearchFromMovimentPesticides"]),
  },
  created() {
    this.handleAssingToEdit();
  },
  mounted() {
    this.getAllSuppliers();
    this.getAllResponsibles();

    if (this.dataSearchFromMovimentPesticides.id) {
      Object.assign(this.dataInventory, this.dataSearchFromMovimentPesticides);
      if (this.dataSearchFromMovimentPesticides.receita) {
        this.receita = this.dataSearchFromMovimentPesticides.receita;
      }
      Object.keys(INITIAL_STATE_MOVIMENT_PESTICIDES).forEach((key) => {
        const ref = this.$refs[key];

        if (ref && "valueInput" in ref)
          this.$refs[key].valueInput = this.dataInventory[key];
        else if (ref && "valueItems" in ref)
          this.$refs[key].valueItems = this.dataInventory[key];
      });
    }
  },
};
</script>
<style scoped>
.BoxFront {
  display: flex;
  margin-left: 30px;
  width: calc(100% - 30px);
  height: 100vh;
  font-size: 12px;
}

.contentFront {
  width: 100%;
  height: auto;
  padding: 0 3rem 0 2.5rem;
}

.selectPlus {
  position: relative;
  width: 33%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.screenProducts {
  align-items: center;
  background: white;
  cursor: pointer;
  display: flex;
  width: 2em;
  height: 2em;
  justify-content: center;
}

.fixedSelect {
  position: absolute;
  font-size: 10px;
  bottom: 15px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.inputTextArea {
  width: 100%;
  text-decoration: none;
  height: 60px;
  resize: none;
  padding-top: 0.3rem;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
}

.rowContainer span {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 25px;
  flex-wrap: wrap;
}

.alertModal {
  font-size: 11px;
  color: rgb(115, 0, 0);
  padding-left: 40px;
  margin: -15px;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #006458;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.rowObservation {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: auto;
  position: relative;
}

.input-group-ob {
  width: 100%;
}

.input-group {
  width: 33%;
}

.user-label-obs {
  position: absolute;
  left: 0px;
  top: 0;
  font-size: 12px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  bottom: 13px;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.user-label-top {
  position: absolute;
  left: 10px;
  font-size: 11px;
  top: 1px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.headerInventory {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.headerInventory span {
  font-weight: 600;
}

/* ----------------------------  */
.formFront {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 1rem;
}

.content-form-btn {
  gap: 20px;
  display: flex;
  width: calc(100% - 60px);
  justify-content: space-between;
  position: fixed;
  background-color: white;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
  bottom: 0;
  left: 60px;
  z-index: 200;
  padding: 0.7% 32px;
}

.form-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #006458;
  border: none;
  color: whitesmoke;
  border-radius: 3px;
  width: 20%;
  height: 28px;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.429);
}

.form-btn-inventory {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  background: #006458;
  border: none;
  color: whitesmoke;
  border-radius: 3px;
  height: 25px;
  margin-bottom: 5px;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.429);
  line-height: 1;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

@media screen and (max-width: 700px) {
  .BoxFront {
    display: flex;
    margin-left: 10px;
    width: 100%;
    height: 100vh;
    font-size: 12px;
    flex-direction: column;
  }

  .contentFront {
    width: 100%;
    height: auto;
    margin-left: 0px;
  }

  .form-btn {
    width: 50%;
    margin-top: 30px;
  }
}
</style>
